<template>
  <section>
    <div class="location">
      <h2>Choose a location</h2>
      <p class="subheading">Enter postcode, city or town near you</p>
      <div>
        <input id="booking-location-search-input" placeholder="" type="text">
        <button type="submit"><img :src="'//' + currentURL + '/app/themes/leightons/images/magnify.png'"/></button>
      </div>
      <div class="map-mobile">
        <div class="filter-option">
          <label>
            <input type="checkbox" v-model="show_only_practices_offering_this_service">
            <p>Show only practices with availability in the next {{getXWeeksValue}} {{getXWeeksValue > 1 ? "weeks" : "week"}}</p>
          </label>
        </div>
        <div class="view-toggle">
          <span class="map-container">
            <button v-show="viewType == 'list'" @click="onShowMap"><img :src="'//' + currentURL + '/app/themes/leightons/images/map-icon-grey.svg'"/><span>View Map</span></button>
            <button v-show="viewType == 'map'" @click="onShowList"><img :src="'//' + currentURL + '/app/themes/leightons/images/list-icon-grey.svg'"/><span>View List</span></button>
          </span>
        </div>
      </div>
    </div>
    <div class="map">
      <button v-show="viewType == 'list'" @click="onShowMap"><img :src="'//' + currentURL + '/app/themes/leightons/images/map-icon-grey.svg'"/> <span>View Map</span></button>
      <button v-show="viewType == 'map'" @click="onShowList"><img :src="'//' + currentURL + '/app/themes/leightons/images/list-icon-grey.svg'"/> <span>View List</span></button>
    </div>

    <booking-location-list v-show="viewType == 'list'"
      :appointment="appointment"
      :pagination="pagination"
      :user_location_cord="user_location_cord"
      :displayed_practices="getPracticeChunkData"
      :all_practices="getFilteredPractices"
      @on-show-more="onShowMorePractices"
      @on-select="selectPractice">

    </booking-location-list>

    <booking-location-map v-show="viewType == 'map'"
      :appointment="appointment"
      :pagination="pagination"
      :user_location_cord="user_location_cord"
      :displayed_practices="getPracticeChunkData"
      :all_practices="getFilteredPractices"
      :visibilityChanged="viewType == 'map'"
      @on-select="selectPractice"
      @on-location-cord-changed="locationCordChange"
      @on-location-cord-reset="locationCordReset">

    </booking-location-map>

    <booking-location-notification v-show="no_booking_practice"
      :practice="no_booking_practice"
      @onclose="(no_booking_practice = null)">
    </booking-location-notification>

    <div class="btn-container">
      <button :disabled="appointment.practice.ID === 0" @click="stage('date')" class="btn">Continue</button>
    </div>
    <template v-if="onAppointmentPracticesChanged"></template>
  </section>
</template>

<script>

import BookingLocationList from "./BookingLocationList.vue";
import BookingLocationMap from "./BookingLocationMap.vue";
import BookingLocationNotification from "./BookingLocationNotification.vue";

const haversine = require("haversine-distance");
export default {

  created() {
    this.currentURL = location.host;
  },

  name: "BookingLocation",
  components: {
    BookingLocationList,
    BookingLocationMap,
    BookingLocationNotification,
  },
  props: ["appointment"],
  data () {
    return {
      currentURL: "",
      search: '',
      viewType: 'list',
      user_location_cord: null,
      save_user_location_cord: null,
      show_only_practices_offering_this_service: true,

      practices_with_distance: [],
      //for show more
      filtered_practices: [],
      filtered_practices_chunks: [],
      pagination: {
          items_per_page: 3,
          current_page: 0,
          total_page: 0
      },

      empty_practice: {
        "ID": 0,
        "post_title": "",
        "post_name": "",
        "ad_location_id": "",
        "ad_address": "",
        "ad_latlng": "",
        "ad_time_slots": [],
        "distance": 0,
        "has_next_appointment": false,
        "next_appointment_info": ""
      },

      no_booking_practice: null,

      MAX_CLOSEST_PRACTICES: -1,//the max number of closest practices to be displayed to the current location, set -1 to display ALL
    }
  },
  methods: {
    onShowList() {
      this.viewType = 'list';
    },
    onShowMap() {
      this.viewType = 'map';
    },
    onShowMorePractices() {
      this.pagination.current_page++;
    },

    stage(stage) {
      this.$emit("stage", stage);
      this.addToGTMDataLayer(2, this.appointment.practice);
    },
    selectPractice(location) {
      if (location && !location.has_next_appointment) {
        //alert("The selected practice is not able to book online at the moment, please try another one.");
        this.no_booking_practice = location;
        location = this.empty_practice;
      }

      // Window scroll to bottom smooth
      window.scrollTo({
        top: document.body.scrollHeight - 300,
        behavior: 'smooth'
      });

      this.$emit('selectPractice', location);
    },
    locationCordChange(newCord) {
      this.user_location_cord = newCord;
      this.calculateDistanceOnLocationChanged();
    },
    locationCordReset() {
      this.user_location_cord = this.save_user_location_cord;
      this.calculateDistanceOnLocationChanged();
    },

    calculateDistanceOnLocationChanged() {
      //start getting the closest pratices to the new location
      this.onGetCurrentPositionDone(null);

      //check if the current selected practice is NOT in the list -> reset to null
      const filteredPractices = this.getFilteredPractices;
      if (this.appointment.practice.ID !== 0 && filteredPractices && filteredPractices.length > 0) {
        const existed = filteredPractices.filter(p => p.ad_location_id === this.appointment.practice.ad_location_id);
        if (existed.length < 1) {
          this.$emit('selectPractice', this.empty_practice);
        }
      } else if (this.appointment.practice.ID !== 0) {
        this.$emit('selectPractice', this.empty_practice);
      }
    },

    getNextAvailableAppointment(practice) {
      if (practice.ad_time_slots && practice.ad_time_slots.length > 0) {
        const serviceId = this.appointment.service.id;
        const slot = practice.ad_time_slots.filter(item => (item.service === serviceId) && (item.id !== ""));
        if (slot.length > 0) {
          return "Next available appointment:<br><span>" + slot[0].start_dateformatter + "</span>";
        }
      }
      return "No appointments available to book online";
    },
    checkPracticeHasNextAppointment(practice) {
      if (practice.ad_time_slots && practice.ad_time_slots.length > 0) {
        const serviceId = this.appointment.service.id;
        const slot = practice.ad_time_slots.filter(item => (item.service === serviceId) && (item.id !== ""));
        if (slot.length > 0) return true;
      }
      return false;
    },
    calculateMilesAway(practice) {
      const points = practice.ad_latlng.split(",");
      if (points.length == 2) {
        const practice_cord = {lat: points[0], lng: points[1]};
        return this.getDistanceFromCurrentLocation(practice_cord);
      }
      return -1;
    },

    onGetCurrentPositionDone(position) {
      if (position) {
        this.user_location_cord = {lat: position.coords.latitude, lng: position.coords.longitude };
        this.save_user_location_cord = this.user_location_cord;
      }
    },

    getDistanceFromCurrentLocation(point) {
      if (this.user_location_cord) {
        const distance = haversine(this.user_location_cord, point) * 0.000621371192;//1 meter = 0.000621371192 miles
        return Math.round(distance*100)/100;
      }
      return 99999;//big distance to sort it at the end
    },

    generateChunks(filteredPractices) {
      let chunked = [];
      const items_per_page = this.pagination.items_per_page;

      //sort filteredPractices by distance ASC, title ASC
      filteredPractices.sort((a, b) => {
          if (a.distance !== b.distance) return a.distance - b.distance;
          return (a.post_title.toLowerCase() < b.post_title.toLowerCase()) ? -1 : 1;
        }
      );

      //get the closest practices to the current location accordingly to MAX_CLOSEST_PRACTICES
      if (this.MAX_CLOSEST_PRACTICES > 0 && filteredPractices.length > this.MAX_CLOSEST_PRACTICES) {
        filteredPractices = filteredPractices.slice(0, this.MAX_CLOSEST_PRACTICES);
      }

      //start chunking the filtered array
      for (let i = 0;  i < filteredPractices.length; i += items_per_page) {
          chunked.push(filteredPractices.slice(i, i + items_per_page));
      }

      this.filtered_practices = filteredPractices;
      //reset the pagination to the begin
      this.filtered_practices_chunks = chunked;
      this.pagination.current_page = 1;
      this.pagination.total_page = chunked.length;
    },

    addDistanceAndNextAppointmentInfo(temp) {
      if (temp && temp.length > 0) {
        for (let index = 0; index < temp.length; index++) {
          temp[index]['distance'] = this.calculateMilesAway(temp[index]);
          temp[index]['has_next_appointment'] = this.checkPracticeHasNextAppointment(temp[index]);
          temp[index]['next_appointment_info'] = this.getNextAvailableAppointment(temp[index]);
        }
      }
      this.practices_with_distance = temp;
    },
    addToGTMDataLayer(step, practice) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'eec.checkout_option',
        'ecommerce': {
          'checkout': {
            actionField: {
              'step': step,
              'option': practice.post_title
            }
          }
        }
      });
    }
  },

  mounted() {
    const thisView = this;
    if(navigator.geolocation){
      navigator.geolocation.getCurrentPosition(
        function(location){
          thisView.onGetCurrentPositionDone(location)
        }, function(){
          thisView.onGetCurrentPositionDone(null)
        }, {
          timeout: 5000
      });
    } else {
      this.onGetCurrentPositionDone(null);
    }
    window.scrollTo(0, 0);
  },

  computed: {
    getXWeeksValue() {
      if (this.appointment.bookingConfigs && this.appointment.bookingConfigs.practices_availability_x_weeks) {
        return parseInt(this.appointment.bookingConfigs.practices_availability_x_weeks);
      }
      return 4;
    },
    onAppointmentPracticesChanged() {
      //calculate the distance to sort and get the nearest locations to the user
      //and check if having next appoinment data
      let temp = this.appointment.practices ?? [];
      this.addDistanceAndNextAppointmentInfo(temp);
      return temp.length > 0;
    },
    getFilteredPractices() {
      if (this.practices_with_distance && this.practices_with_distance.length > 0) {

        let temp = [];
        //filter only practices offering to the active service
        const active_service_code = this.appointment.service.code;
        if (this.show_only_practices_offering_this_service) {
          //fillter with available in X weeks
          //temp = this.practices_with_distance.filter(item => item.service_codes.indexOf(active_service_code) > -1);
          const thisView = this;
          temp = this.practices_with_distance.filter(item => {

            let availability = item.has_next_appointment && (item.service_codes.indexOf(active_service_code) > -1);
            const x_weeks = thisView.getXWeeksValue;
            const time_slots = item.ad_time_slots;
            let in_x_weeks = false;
            if (time_slots.length > 0) {
              let nextXWeeks = new Date();
              nextXWeeks.setDate(nextXWeeks.getDate()+ 7*x_weeks);
              nextXWeeks.setHours(23, 0, 0);

              for (let index = 0; index < time_slots.length; index++) {
                const element = time_slots[index];
                if (element.service === this.appointment.service.id) {
                  let startDate = element.start;
                  startDate = startDate.replace("+00:00","");
                  const theDate = new Date(startDate);
                  in_x_weeks = (theDate.getTime() < nextXWeeks.getTime());
                  break;
                }
              }
            }

            return availability && in_x_weeks;
          });
        } else {
          temp = this.practices_with_distance.filter(item => item.service_codes.indexOf(active_service_code) > -1);
        }

        this.generateChunks(temp);
        return this.filtered_practices;
      }
      return [];
    },
    getPracticeChunkData() {
        if (this.pagination.total_page > 0) {
          if (this.pagination.current_page <= this.pagination.total_page) {
              let chunks = [];
              for (let index = 0; index < this.pagination.current_page; index++) {
                const elements = this.filtered_practices_chunks[index];
                chunks = chunks.concat(elements);
              }
              return chunks;
          }
        }
        return [];
    }
  }
};
</script>

<style lang="postcss" scoped>
section {
  @apply relative w-full pt-[45px] pb-0;

  h2 {
    @apply border-b border-purple-darker pb-4 m-0 mb-5;
  }

  p {
    @apply text-xl;
  }

  .subheading {
    @apply max-w-[400px] mx-auto tracking-wide sm:text-left text-[16px] sm:text-[20px] mb-[20px] text-grey-darker;
  }

  .btn-container {
    @apply sticky inset-x-0 bottom-0 bg-white shadow-md flex justify-center items-center h-[110px] px-[30px];
    box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.1);

    button.btn {
      @apply w-full sm:w-auto mx-auto;
    }
  }

  .location {
    @apply sm:w-[460px] mx-auto text-center px-[30px] sm:px-0;

    div:first-of-type {
      @apply mb-[30px] flex;

      input[type=text] {
        @apply w-full p-[10px] rounded-l-lg border-y border-l border-[#62829B];

        &:focus {
                outline: none;
                box-shadow: 0 0 5px rgba(81, 203, 238, 1);
                border: 1px solid #888;
            }
      }

      button {
        @apply bg-purple-darker px-[15px] rounded-r-lg;
      }
    }

    .map-mobile {
      @apply w-full flex md:justify-center text-left items-center;

      .filter-option {
        @apply mb-0;

        label {
          @apply flex w-full items-center;

          input[type=checkbox] {
              @apply w-[20px] sm:w-[30px] h-[20px] sm:h-[30px] border-[#62829B] border mt-[4px] sm:mt-0;
          }

          input[type=checkbox]:checked {
              @apply accent-purple-darker;
          }

          p {
            @apply text-grey-darker text-[14px] leading-[18px] px-5 sm:text-[16px] sm:pt-[3px];

            br {
              @apply sm:hidden block
            }
          }
        }
      }

      .view-toggle {
        @apply block sm:hidden w-[30%];

        .map-container {
          @apply flex justify-end border-l border-navy/20 h-full content-center ml-[10px];
        }

        button {
          @apply text-grey-darker flex font-avenir-medium text-base items-center;

          &:hover {

            span {
              @apply underline;
            }
          }

          img {
            @apply mr-[5px] sm:mr-[10px] ml-[10px] -mt-[2px];
          }
        }
      }
    }
  }

  .map {
    @apply sm:block hidden pr-[30px] xl:pr-0;

    button {
      @apply text-grey-darker ml-auto flex justify-end font-avenir-medium text-base;

      img {
        @apply mr-[10px] mt-[5px];
      }

      &:hover {

        span {
          @apply underline;
        }
      }
    }
  }
}

@media (min-width:1300px) {
  section {
    .map {
      button {
        @apply w-[1300px] mr-auto;
      }
    }
  }
}
</style>
